/* =============================
Wuthering Waves (Multi) Catalog (Standard)
Auto-generated from config
Pattern: unified
============================= */
(function () {
const API_SOURCES = {
'green': {
name: 'Green Source (Scraper)',
enabled: true,
priority: 1,
idPrefix: 'WW04',
prefixes: ['mc5_','mc_'],
unwanted: new Set(['停驻之烟','擎渊怒涛','浩境粼光','漪澜浮录','千古洑流','玻色星仪','相位涟漪','脉冲协臂','血誓盟约','镭射切变','源能机锋','America','Europe','Asia','SEA','HMT','HK,TW,MAC','衍射女','衍射男','男','女','Gender','Server','Email','Level','性别','区服']),
nameKey: 'name',
idKey: 'id',
imageKey: 'pic',
root: 'c',
extra_data: {}
},
'mxwy': {
name: 'MXWY Source (V2)',
enabled: true,
priority: 2,
idPrefix: 'WW02',
prefixes: ['mc5_','mc_'],
unwanted: new Set(['停驻之烟','擎渊怒涛','浩境粼光','漪澜浮录','千古洑流','玻色星仪','相位涟漪','脉冲协臂','血誓盟约','镭射切变','源能机锋','America','Europe','Asia','SEA','HMT','HK,TW,MAC','衍射女','衍射男','男','女','Gender','Server','Email','Level','性别','区服']),
nameKey: 'name',
idKey: 'id',
imageKey: 'role_img',
root: '',
extra_data: {}
},
'bssy': {
name: 'BSSY Source (V1)',
enabled: true,
priority: 3,
idPrefix: 'WW03',
prefixes: ['mc5_','mc_'],
unwanted: new Set(['停驻之烟','擎渊怒涛','浩境粼光','漪澜浮录','千古洑流','玻色星仪','相位涟漪','脉冲协臂','血誓盟约','镭射切变','源能机锋','America','Europe','Asia','SEA','HMT','HK,TW,MAC','衍射女','衍射男','男','女','Gender','Server','Email','Level','性别','区服']),
nameKey: 'name',
idKey: 'card_id',
imageKey: 'img_url',
root: 'data',
extra_data: {}
},
'chushi': {
name: 'Chushi Premium',
enabled: true,
priority: 4,
idPrefix: 'WW01',
prefixes: ['mc5_','mc_'],
unwanted: new Set(['停驻之烟','擎渊怒涛','浩境粼光','漪澜浮录','千古洑流','玻色星仪','相位涟漪','脉冲协臂','血誓盟约','镭射切变','源能机锋','America','Europe','Asia','SEA','HMT','HK,TW,MAC','衍射女','衍射男','男','女','Gender','Server','Email','Level','性别','区服']),
nameKey: 'name',
idKey: 'id',
imageKey: 'img_url',
root: 'data.items',
extra_data: {}
},
'kikiyx': {
name: 'Kikiyx Scrap',
enabled: true,
priority: 5,
idPrefix: 'WW05',
prefixes: ['mc5_','mc_'],
unwanted: new Set(['停驻之烟','擎渊怒涛','浩境粼光','漪澜浮录','千古洑流','玻色星仪','相位涟漪','脉冲协臂','血誓盟约','镭射切变','源能机锋','America','Europe','Asia','SEA','HMT','HK,TW,MAC','衍射女','衍射男','男','女','Gender','Server','Email','Level','性别','区服']),
nameKey: 'name',
idKey: 'id',
imageKey: 'img_url',
root: 'results',
extra_data: {}
}
};

const GREEN_BASE = 'https://nodejs-serverless-function-express-delta-ten-11.vercel.app/api/wuwa-multi-proxy?source=green';
const MXWY_BASE = 'https://nodejs-serverless-function-express-delta-ten-11.vercel.app/api/wuwa-multi-proxy?source=mxwy';
const BSSY_BASE = 'https://nodejs-serverless-function-express-delta-ten-11.vercel.app/api/wuwa-multi-proxy?source=bssy';
const CHUSHI_BASE = 'https://www.chushi.shop/gamefun/api/game/frontend';
const KIKIYX_BASE = 'https://nodejs-serverless-function-express-delta-ten-11.vercel.app/api/wuwa-multi-proxy?source=kikiyx';

let selected = {}; /* Keyed by Display Name */

/* Lazy Loading State */
let allSearchResults = [];
let renderedCount = 0;
const BATCH_SIZE = 24;
let resultObserver = null;

/* ====== Dynamic Partials Inclusion ====== */
/* SCROLL LOGIC */
const initResultObserver = () => {
if (resultObserver) resultObserver.disconnect();
resultObserver = GachaUtils.createSentinelObserver({
hasMoreBatch: () => renderedCount < allSearchResults.length,
onBatch: () => renderBatch()
}); };
/* UI UPDATES */
const updateSelectedUI = () => {
const totalCount = Object.values(selected).reduce((sum, sel) => sum + (sel.count || 0), 0);
const el = document.querySelector("#selectedCount");
if (el) el.textContent = totalCount;
};

const scrollToResults = GachaUtils.scrollToResults;

const updateThumbDisplay = (thumb, key) => {
GachaUtils.updateThumbDisplay(thumb, selected[key]?.count || 0);
};
/* CLIPBOARD — use GachaUtils shared versions */
const escapeHtml = GachaUtils.escapeHtml;
const showToast = GachaUtils.showToast;
const copyToClipboard = GachaUtils.copyToClipboard;

const normalizeString = (name, prefixes) => {
    if (!name) return '';
    let n = String(name).trim();
    if (prefixes) prefixes.forEach(p => { if (n.startsWith(p)) n = n.slice(p.length); });
    return n;
};

const getResultsArray = (payload, apiId) => {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload;

    const config = API_SOURCES[apiId];
    /* Try mapping root first */
    if (config && config.root) {
        const parts = config.root.split('.');
        let cur = payload;
        for (const p of parts) if (cur) cur = cur[p];
        if (Array.isArray(cur)) return cur;
    }

    /* Try common patterns (including robustness fix from ZXW) */
    return payload.results || payload.items || payload.data?.items || payload.data?.records || payload.data || (Array.isArray(payload.c) ? payload.c : []);
};

/* SETTINGS */
/*======Settings & API Registry======*/
let appSettings = { translations_json: '{}', images_json: '{}', api_toggles: {}, api_priority: {} };
const logger = {
log: (...args) => { if (appSettings.enable_debug) console.log(...args); },
warn: (...args) => { if (appSettings.enable_debug) console.warn(...args); },
error: (...args) => { console.error(...args); } /* Errors always show */
};

try {
const el = document.getElementById('catalog-settings-wuwa-multi');
if (el) appSettings = JSON.parse(el.textContent);

if (appSettings.api_toggles) {
Object.keys(API_SOURCES).forEach(apiId => {
if (appSettings.api_toggles.hasOwnProperty(apiId)) {
API_SOURCES[apiId].enabled = appSettings.api_toggles[apiId] === true;
}
if (appSettings.api_names && appSettings.api_names[apiId]) {
API_SOURCES[apiId].name = appSettings.api_names[apiId];
}
if (appSettings.api_priority && appSettings.api_priority.hasOwnProperty(apiId)) {
API_SOURCES[apiId].priority = parseInt(appSettings.api_priority[apiId], 10);
}
});
}
} catch (e) { }
/* TRANSLATIONS */
const nameTranslationsMap = GachaUtils.buildTranslationMap(appSettings.translations_json);
const customImagesMap = GachaUtils.buildImageMap(appSettings.images_json);

const translateName = name => nameTranslationsMap[name] || name;
const getCustomImage = name => customImagesMap[name] || null;
/* ID HANDLER */
/*======ID Transformation======*/
function privateToPublicID(privateID, source) {
    if (!privateID) return '';
    var providerCode = GachaUtils.PROVIDER_IDS[source] || '__';
    return GachaUtils.obfuscateIdV2(privateID, providerCode, 'WW');
}

function publicToPrivateID(publicID) {
    return GachaUtils.deobfuscateIdV2(publicID);
}



/* CATALOG SPECIFIC RESOURCE FETCHER */
/* ====== RESOURCE FETCHER (Multi-API Wuwa) ====== */
const loadResources = () => {
logger.log('🚀 [Wuwa] Initializing multi-source resource loading...');
const resourcePromises = [];

if (API_SOURCES['green'].enabled) {
const url = GREEN_BASE + '&action=getCarts&game=105';

logger.log('📡 [Wuwa] Fetching Green Source (Scraper) characters:', url);
resourcePromises.push(
fetch(url).then(r => r.json()).catch(err => {
logger.warn('⚠️ [Wuwa] Green Source (Scraper) fetch failed:', err);
return null;
})
);
} else {
logger.log('🚫 [Wuwa] Green Source (Scraper) is disabled.');
resourcePromises.push(Promise.resolve(null));
}
if (API_SOURCES['mxwy'].enabled) {
const url = MXWY_BASE + '&action=image&url=' + encodeURIComponent('http://mxwy.ltd/api/card/?game=鸣潮&tag=五星');

logger.log('📡 [Wuwa] Fetching MXWY Source (V2) characters:', url);
resourcePromises.push(
fetch(url).then(r => r.json()).catch(err => {
logger.warn('⚠️ [Wuwa] MXWY Source (V2) fetch failed:', err);
return null;
})
);
} else {
logger.log('🚫 [Wuwa] MXWY Source (V2) is disabled.');
resourcePromises.push(Promise.resolve(null));
}
if (API_SOURCES['bssy'].enabled) {
const url = BSSY_BASE + '&action=image&url=' + encodeURIComponent('http://bssy.top/api/card/?game=鸣潮&tag=五星');

logger.log('📡 [Wuwa] Fetching BSSY Source (V1) characters:', url);
resourcePromises.push(
fetch(url).then(r => r.json()).catch(err => {
logger.warn('⚠️ [Wuwa] BSSY Source (V1) fetch failed:', err);
return null;
})
);
} else {
logger.log('🚫 [Wuwa] BSSY Source (V1) is disabled.');
resourcePromises.push(Promise.resolve(null));
}
if (API_SOURCES['chushi'].enabled) {
const url = CHUSHI_BASE + '/resource/get?game_id=2';

logger.log('📡 [Wuwa] Fetching Chushi Premium characters:', url);
resourcePromises.push(
fetch(url).then(r => r.json()).catch(err => {
logger.warn('⚠️ [Wuwa] Chushi Premium fetch failed:', err);
return null;
})
);
} else {
logger.log('🚫 [Wuwa] Chushi Premium is disabled.');
resourcePromises.push(Promise.resolve(null));
}
if (API_SOURCES['kikiyx'].enabled) {
const url = KIKIYX_BASE + '&action=list';

logger.log('📡 [Wuwa] Fetching Kikiyx Scrap characters:', url);
resourcePromises.push(
fetch(url).then(r => r.json()).catch(err => {
logger.warn('⚠️ [Wuwa] Kikiyx Scrap fetch failed:', err);
return null;
})
);
} else {
logger.log('🚫 [Wuwa] Kikiyx Scrap is disabled.');
resourcePromises.push(Promise.resolve(null));
}

Promise.all(resourcePromises).then(results => {
logger.log('✅ [Wuwa] All network requests complete.');
let resultIdx = 0;
const apiData = {};

{
const raw = results[resultIdx++];
const config = API_SOURCES['green'];
logger.log('📦 [Wuwa] Processing ' + config.name + ' raw data:', raw);

const dataArray = getResultsArray(raw, 'green');
apiData['green'] = Array.isArray(dataArray) ? dataArray : [];
logger.log('📊 [Wuwa] ' + config.name + ' processed items:', apiData['green'].length);

// Static server mapping
const sMap = {};
sMap['Asia'] = '7893';
sMap['SEA'] = '7894';
sMap['America'] = '7895';
window._greenServerMap = sMap;
}
{
const raw = results[resultIdx++];
const config = API_SOURCES['mxwy'];
logger.log('📦 [Wuwa] Processing ' + config.name + ' raw data:', raw);

const dataArray = getResultsArray(raw, 'mxwy');
apiData['mxwy'] = Array.isArray(dataArray) ? dataArray : [];
logger.log('📊 [Wuwa] ' + config.name + ' processed items:', apiData['mxwy'].length);

// Static server mapping
const sMap = {};
sMap['Asia'] = '13898';
sMap['SEA'] = '13901';
sMap['Europe'] = '13899';
sMap['America'] = '13897';
window._mxwyServerMap = sMap;
}
{
const raw = results[resultIdx++];
const config = API_SOURCES['bssy'];
logger.log('📦 [Wuwa] Processing ' + config.name + ' raw data:', raw);

const dataArray = getResultsArray(raw, 'bssy');
apiData['bssy'] = Array.isArray(dataArray) ? dataArray : [];
logger.log('📊 [Wuwa] ' + config.name + ' processed items:', apiData['bssy'].length);

// Static server mapping
const sMap = {};
sMap['Asia'] = '13898';
sMap['SEA'] = '13901';
sMap['Europe'] = '13899';
sMap['America'] = '13897';
window._bssyServerMap = sMap;
}
{
const raw = results[resultIdx++];
const config = API_SOURCES['chushi'];
logger.log('📦 [Wuwa] Processing ' + config.name + ' raw data:', raw);

const dataArray = getResultsArray(raw, 'chushi');
apiData['chushi'] = Array.isArray(dataArray) ? dataArray : [];
logger.log('📊 [Wuwa] ' + config.name + ' processed items:', apiData['chushi'].length);

// Static server mapping
const sMap = {};
window._chushiServerMap = sMap;
}
{
const raw = results[resultIdx++];
const config = API_SOURCES['kikiyx'];
logger.log('📦 [Wuwa] Processing ' + config.name + ' raw data:', raw);

const dataArray = getResultsArray(raw, 'kikiyx');
apiData['kikiyx'] = Array.isArray(dataArray) ? dataArray : [];
logger.log('📊 [Wuwa] ' + config.name + ' processed items:', apiData['kikiyx'].length);

// Static server mapping
const sMap = {};
sMap['Asia'] = 'A01';
sMap['SEA'] = 'A02';
sMap['Europe'] = 'A03';
sMap['America'] = 'A04';
sMap['HMT'] = 'A05';
window._kikiyxServerMap = sMap;
}

// Pass to merger
mergeToRegistry(apiData);
}).catch(e => {
logger.error('❌ [Wuwa] Critical merge error:', e);
const res = document.querySelector("#filters");
if (res) res.innerHTML = '<div class="no-data">Failed to load character list. Check console.</div>';
});
};





/* CATALOG SPECIFIC REGISTRY MERGER */
/* ====== REGISTRY MERGER (Multi-API Wuwa) ====== */
const mergeToRegistry = (apiData) => {
logger.log('🖇️ [Wuwa] Merging all sources into character registry...');
const merged = {};

if (apiData['green'] && apiData['green'].length > 0) {
const config = API_SOURCES['green'];
logger.log(`🖇️ [Wuwa] Merging ${config.name} into registry...`);

apiData['green'].forEach(item => {
const rawName = item[config.nameKey] || item.name;
const norm = normalizeString(rawName, config.prefixes);
if (config.unwanted.has(norm)) return;

const displayLabel = translateName(norm);
let itemImg = item[config.imageKey] || item.img_url || item.role_img || item.card_img || item.pic;

if (!merged[displayLabel]) {
merged[displayLabel] = {
displayLabel: displayLabel,
normName: norm,
rawNames: new Set([rawName, norm, displayLabel]),
_green_id: String(item[config.idKey] || item.id),
img: itemImg
};
} else {
merged[displayLabel]._green_id = String(item[config.idKey] || item.id);
if (!merged[displayLabel].img) merged[displayLabel].img = itemImg;
merged[displayLabel].rawNames.add(rawName);
merged[displayLabel].rawNames.add(norm);
}
});}
if (apiData['mxwy'] && apiData['mxwy'].length > 0) {
const config = API_SOURCES['mxwy'];
logger.log(`🖇️ [Wuwa] Merging ${config.name} into registry...`);

apiData['mxwy'].forEach(item => {
const rawName = item[config.nameKey] || item.name;
const norm = normalizeString(rawName, config.prefixes);
if (config.unwanted.has(norm)) return;

const displayLabel = translateName(norm);
let itemImg = item[config.imageKey] || item.img_url || item.role_img || item.card_img || item.pic;

if (!merged[displayLabel]) {
merged[displayLabel] = {
displayLabel: displayLabel,
normName: norm,
rawNames: new Set([rawName, norm, displayLabel]),
_mxwy_id: String(item[config.idKey] || item.id),
img: itemImg
};
} else {
merged[displayLabel]._mxwy_id = String(item[config.idKey] || item.id);
if (!merged[displayLabel].img) merged[displayLabel].img = itemImg;
merged[displayLabel].rawNames.add(rawName);
merged[displayLabel].rawNames.add(norm);
}
});}
if (apiData['bssy'] && apiData['bssy'].length > 0) {
const config = API_SOURCES['bssy'];
logger.log(`🖇️ [Wuwa] Merging ${config.name} into registry...`);

apiData['bssy'].forEach(item => {
const rawName = item[config.nameKey] || item.name;
const norm = normalizeString(rawName, config.prefixes);
if (config.unwanted.has(norm)) return;

const displayLabel = translateName(norm);
let itemImg = item[config.imageKey] || item.img_url || item.role_img || item.card_img || item.pic;

if (!merged[displayLabel]) {
merged[displayLabel] = {
displayLabel: displayLabel,
normName: norm,
rawNames: new Set([rawName, norm, displayLabel]),
_bssy_id: String(item[config.idKey] || item.id),
img: itemImg
};
} else {
merged[displayLabel]._bssy_id = String(item[config.idKey] || item.id);
if (!merged[displayLabel].img) merged[displayLabel].img = itemImg;
merged[displayLabel].rawNames.add(rawName);
merged[displayLabel].rawNames.add(norm);
}
});}
if (apiData['chushi'] && apiData['chushi'].length > 0) {
const config = API_SOURCES['chushi'];
logger.log(`🖇️ [Wuwa] Merging ${config.name} into registry...`);

apiData['chushi'].forEach(item => {
const rawName = item[config.nameKey] || item.name;
const norm = normalizeString(rawName, config.prefixes);
if (config.unwanted.has(norm)) return;

const displayLabel = translateName(norm);
let itemImg = item[config.imageKey] || item.img_url || item.role_img || item.card_img || item.pic;

if (!merged[displayLabel]) {
merged[displayLabel] = {
displayLabel: displayLabel,
normName: norm,
rawNames: new Set([rawName, norm, displayLabel]),
_chushi_id: String(item[config.idKey] || item.id),
img: itemImg
};
} else {
merged[displayLabel]._chushi_id = String(item[config.idKey] || item.id);
if (!merged[displayLabel].img) merged[displayLabel].img = itemImg;
merged[displayLabel].rawNames.add(rawName);
merged[displayLabel].rawNames.add(norm);
}
});}
if (apiData['kikiyx'] && apiData['kikiyx'].length > 0) {
const config = API_SOURCES['kikiyx'];
logger.log(`🖇️ [Wuwa] Merging ${config.name} into registry...`);

apiData['kikiyx'].forEach(item => {
const rawName = item[config.nameKey] || item.name;
const norm = normalizeString(rawName, config.prefixes);
if (config.unwanted.has(norm)) return;

const displayLabel = translateName(norm);
let itemImg = item[config.imageKey] || item.img_url || item.role_img || item.card_img || item.pic;

if (!merged[displayLabel]) {
merged[displayLabel] = {
displayLabel: displayLabel,
normName: norm,
rawNames: new Set([rawName, norm, displayLabel]),
_kikiyx_id: String(item[config.idKey] || item.id),
img: itemImg
};
} else {
merged[displayLabel]._kikiyx_id = String(item[config.idKey] || item.id);
if (!merged[displayLabel].img) merged[displayLabel].img = itemImg;
merged[displayLabel].rawNames.add(rawName);
merged[displayLabel].rawNames.add(norm);
}
});}

let allItems = Object.values(merged);

// --- Sort characters by character_order_source if set ---
const orderSource = appSettings.character_order_source;
if (orderSource && apiData[orderSource]) {
logger.log('⚖️ [Wuwa] Sorting characters by', orderSource, 'order...');
const orderMap = new Map();
const refItems = apiData[orderSource];
const config = API_SOURCES[orderSource];

let rank = 0;
refItems.forEach(item => {
const raw = item[config.nameKey] || item.name;
if (!raw) return;
const norm = normalizeString(raw, config.prefixes);
const std = translateName(norm);
if (!orderMap.has(std)) orderMap.set(std, rank++);
});

allItems.sort((a, b) => {
const rankA = orderMap.has(a.displayLabel) ? orderMap.get(a.displayLabel) : 10000;
const rankB = orderMap.has(b.displayLabel) ? orderMap.get(b.displayLabel) : 10000;
if (rankA !== rankB) return rankA - rankB;
return a.displayLabel.localeCompare(b.displayLabel);
});
}

logger.log('🎨 [Wuwa] Rendering', allItems.length, 'total unique characters.');
window._characterImageMap = {};
allItems.forEach(it => {
if (it.img) window._characterImageMap[it.displayLabel] = it.img;
});

renderFilters(allItems);
};

/* FILTER RENDERER */
const renderFilters = (items) => {
const container = document.querySelector("#filters");
if (!container) return;
container.innerHTML = '';

items.forEach(it => {
const thumb = document.createElement('div');
const displayLabel = it.displayLabel;

/* Resolve custom image: try normalized name first (old behavior), then standard label, then raw */
let imgSrc = getCustomImage(it.normName) || getCustomImage(it.displayLabel);
if (!imgSrc) {
for (let r of it.rawNames) {
imgSrc = getCustomImage(r);
if (imgSrc) break;
}
}
const finalImg = imgSrc || it.img;

thumb.className = 'thumb';
thumb.dataset.greenId = it._green_id || '';
thumb.dataset.mxwyId = it._mxwy_id || '';
thumb.dataset.bssyId = it._bssy_id || '';
thumb.dataset.chushiId = it._chushi_id || '';
thumb.dataset.kikiyxId = it._kikiyx_id || '';
thumb.dataset.displayLabel = displayLabel;

thumb.innerHTML = `<div class="thumb-img-container"><img alt="${displayLabel}" src="${finalImg || ''}" loading="lazy" />
</div>
<div class="label">${displayLabel}</div>`;
thumb.onclick = () => {
const key = thumb.dataset.displayLabel;
if (selected[key]) {
selected[key].count++;
} else {
selected[key] = {
count: 1,
greenId: thumb.dataset.greenId,
mxwyId: thumb.dataset.mxwyId,
bssyId: thumb.dataset.bssyId,
chushiId: thumb.dataset.chushiId,
kikiyxId: thumb.dataset.kikiyxId,
rawNames: Array.from(it.rawNames)
};
}
updateThumbDisplay(thumb, key);
updateSelectedUI();
};
container.appendChild(thumb);
});
};



/* CATALOG SPECIFIC SEARCH LOGIC */
/* ====== SEARCH LOGIC (Multi-API Wuwa) ====== */

// Build has-map from a search result item
const buildHasMap = (acc) => {
let has = {};
if (acc.deck_info) {
try { has = typeof acc.deck_info === 'string' ? JSON.parse(acc.deck_info) : acc.deck_info; } catch (e) { }
} else if (acc.items) {
acc.items.forEach(it => { has[it.name] = (has[it.name] || 0) + (it.count || 1); });
}
return has;
};

// Check if an account satisfies ALL selected characters at the required count
const accountMatchesSelection = (has, selectedKeys) => {
return selectedKeys.every(k => {
const req = selected[k];
return req.rawNames.some(rn => (has[rn] || 0) >= req.count);
});
};

const performSearch = () => {
const selectedKeys = Object.keys(selected).filter(k => selected[k].count > 0);
if (selectedKeys.length === 0) {
alert("Please select at least one character before searching.");
return;
}

const res = document.querySelector("#results");
if (res) res.innerHTML = '<div class="no-data">Searching across all sources...</div>';
scrollToResults();

const serverSelect = document.querySelector("#serverSelect");
const server = serverSelect ? serverSelect.value : '';
const promises = [];

if (API_SOURCES['green'].enabled) {
let c = [];
selectedKeys.forEach(k => {
if (selected[k].greenId) {
for (let i = 0; i < selected[k].count; i++) c.push(selected[k].greenId); } }); const
    sid=window._greenServerMap?.[server] || '' ; if (server && sid) c = [sid, ...c];
const url = GREEN_BASE + '&key=' + encodeURIComponent(c.join(','));
promises.push(fetch(url).then(r => r.json()).catch(() => ({ results: [] })));



    } else {
    promises.push(Promise.resolve(null));
    }
if (API_SOURCES['mxwy'].enabled) {
let c = [];
selectedKeys.forEach(k => {
if (selected[k].mxwyId) {
for (let i = 0; i < selected[k].count; i++) c.push(selected[k].mxwyId); } }); const
    sid=window._mxwyServerMap?.[server] || '' ; if (server && sid) c = [sid, ...c];
const nativeSearchUrl = 'http://mxwy.ltd/api/deck/?game=' + encodeURIComponent('鸣潮') +
'&limit=&sid=&deckid=&asort=desc&cards=' + encodeURIComponent(c.join('|'));
const url = MXWY_BASE + '&url=' + encodeURIComponent(nativeSearchUrl);
promises.push(fetch(url).then(r => r.json()).catch(() => ({ results: [] })));



    } else {
    promises.push(Promise.resolve(null));
    }
if (API_SOURCES['bssy'].enabled) {
let c = [];
selectedKeys.forEach(k => {
if (selected[k].bssyId) {
for (let i = 0; i < selected[k].count; i++) c.push(selected[k].bssyId); } }); const
    sid=window._bssyServerMap?.[server] || '' ; if (server && sid) c = [sid, ...c];
const nativeSearchUrl = 'http://bssy.top/api/deck/?game=' + encodeURIComponent('鸣潮') +
'&limit=&sid=&deckid=&asort=desc&cards=' + encodeURIComponent(c.join('|'));
const url = BSSY_BASE + '&url=' + encodeURIComponent(nativeSearchUrl);
promises.push(fetch(url).then(r => r.json()).catch(() => ({ data: [] })));



    } else {
    promises.push(Promise.resolve(null));
    }
if (API_SOURCES['chushi'].enabled) {
let c = [];
selectedKeys.forEach(k => {
if (selected[k].chushiId) {
for (let i = 0; i < selected[k].count; i++) c.push(selected[k].chushiId); } }); const
    sid=window._chushiServerMap?.[server] || '' ; let url = CHUSHI_BASE + '/resource/search?game_id=2&code=&description=' + encodeURIComponent(server);
const g = {};
selectedKeys.forEach(k => { if (selected[k].chushiId) g[selected[k].chushiId] = selected[k].count; });
url += '&groups=' + encodeURIComponent(JSON.stringify(g));
promises.push(fetch(url).then(r => r.json()).catch(() => ({ data: { items: [] } })));



    } else {
    promises.push(Promise.resolve(null));
    }
if (API_SOURCES['kikiyx'].enabled) {
let c = [];
selectedKeys.forEach(k => {
if (selected[k].kikiyxId) {
for (let i = 0; i < selected[k].count; i++) c.push(selected[k].kikiyxId); } }); const
    sid=window._kikiyxServerMap?.[server] || '' ; const body = new URLSearchParams();
selectedKeys.forEach(k => {
if (selected[k].kikiyxId) {
for (let i = 0; i < selected[k].count; i++) body.append('cards', selected[k].kikiyxId); } }); if (server)
    body.append('server', server); promises.push(fetch(KIKIYX_BASE, { method: 'POST' , headers:
    { 'Content-Type' : 'application/x-www-form-urlencoded' }, body: body.toString() }).then(r=> r.json()).catch(() => ({
    results: [] })));



    } else {
    promises.push(Promise.resolve(null));
    }

    Promise.all(promises).then(responses => {
    const combinedResults = [];
    let idx = 0;

    {
    const raw = responses[idx++];
    if (raw) {
    let items = getResultsArray(raw, 'green');
    
    if (server) {
    items = items.filter(d => {
    let di = {};
    try { di = typeof d.deck_info === 'string' ? JSON.parse(d.deck_info) : d.deck_info; } catch (e) { }
    if (di && Object.keys(di).some(k => normalizeString(k, API_SOURCES['green'].prefixes) === server)) return true;
    if (d.server && normalizeString(String(d.server), API_SOURCES['green'].prefixes) === server) return true;
    return false;
    });
    }
    
    items = items.filter(acc => accountMatchesSelection(buildHasMap(acc), selectedKeys));
    items.forEach(item => {
    item._src = 'green';
    item._p = API_SOURCES['green'].priority;
    combinedResults.push(item);
    });
    }
    }    {
    const raw = responses[idx++];
    if (raw) {
    let items = getResultsArray(raw, 'mxwy');
    
    if (server) {
    items = items.filter(d => {
    let di = {};
    try { di = typeof d.deck_info === 'string' ? JSON.parse(d.deck_info) : d.deck_info; } catch (e) { }
    return di && Object.keys(di).some(k => normalizeString(k, API_SOURCES['mxwy'].prefixes) === server);
    });
    }
    
    items = items.filter(acc => accountMatchesSelection(buildHasMap(acc), selectedKeys));
    items.forEach(item => {
    item._src = 'mxwy';
    item._p = API_SOURCES['mxwy'].priority;
    combinedResults.push(item);
    });
    }
    }    {
    const raw = responses[idx++];
    if (raw) {
    let items = getResultsArray(raw, 'bssy');
    
    if (server) {
    items = items.filter(d => {
    let di = {};
    try { di = typeof d.deck_info === 'string' ? JSON.parse(d.deck_info) : d.deck_info; } catch (e) { }
    return di && Object.keys(di).some(k => normalizeString(k, API_SOURCES['bssy'].prefixes) === server);
    });
    }
    
    items = items.filter(acc => accountMatchesSelection(buildHasMap(acc), selectedKeys));
    items.forEach(item => {
    item._src = 'bssy';
    item._p = API_SOURCES['bssy'].priority;
    combinedResults.push(item);
    });
    }
    }    {
    const raw = responses[idx++];
    if (raw) {
    let items = getResultsArray(raw, 'chushi');
    
    if (server) {
    items = items.filter(acc => {
    const desc = acc.description || '';
    return desc.toLowerCase().includes(server.toLowerCase());
    });
    }
    
    items = items.filter(acc => accountMatchesSelection(buildHasMap(acc), selectedKeys));
    items.forEach(item => {
    item._src = 'chushi';
    item._p = API_SOURCES['chushi'].priority;
    combinedResults.push(item);
    });
    }
    }    {
    const raw = responses[idx++];
    if (raw) {
    let items = getResultsArray(raw, 'kikiyx');
    
    if (server) {
    const KIKIYX_SERVER_MAP = { 'Asia': 'A01', 'SEA': 'A02', 'Europe': 'A03', 'America': 'A04', 'HMT': 'A05' };
    const code = KIKIYX_SERVER_MAP[server];
    if (code) items = items.filter(d => d.cards && String(d.cards).includes(code));
    }
    
    items = items.filter(acc => accountMatchesSelection(buildHasMap(acc), selectedKeys));
    items.forEach(item => {
    item._src = 'kikiyx';
    item._p = API_SOURCES['kikiyx'].priority;
    combinedResults.push(item);
    });
    }
    }
    renderResults(combinedResults);
    }).catch(e => {
    logger.error('❌ [Wuwa] Search error:', e);
    if (res) res.innerHTML = '<div class="no-data">Search failed. Check console.</div>';
    });
    };

    const renderResults = (results) => {
    allSearchResults = results;
    renderedCount = 0;
    const res = document.querySelector("#results");
    if (!res) return;
    res.innerHTML = "";
    if (results.length === 0) {
    res.innerHTML = '<div class="no-data">No accounts found matching your selection.</div>';
    return;
    }
    // Read current sort mode — count sorts BYPASS priority; default = priority
    const sortMode = document.getElementById('sortSelect')?.value || 'default';
    if (sortMode === 'count_desc') {
    allSearchResults.sort((a, b) => calculateAccountTotal(b) - calculateAccountTotal(a));
    } else if (sortMode === 'count_asc') {
    allSearchResults.sort((a, b) => calculateAccountTotal(a) - calculateAccountTotal(b));
    } else {
    allSearchResults.sort((a, b) => (a._p || 0) - (b._p || 0));
    }
    initResultObserver();
    renderBatch();
    };


/* CATALOG SPECIFIC RESULT CONTROLLER */
/* ====== RESULT CONTROLLER (Multi-API Wuwa) ====== */
/* ====== Sorting Logic ====== */
const calculateAccountTotal = (item) => {
let total = 0;
const apiConf = API_SOURCES[item._src];
if (!apiConf) return 0;

// Normalize item data structure
let has = {};
if (item.deck_info) {
try { has = typeof item.deck_info === 'string' ? JSON.parse(item.deck_info) : item.deck_info; } catch (e) { }
} else if (item.items) {
item.items.forEach(it => { has[it.name] = (has[it.name] || 0) + (it.count || 1); });
}

const prefixes = apiConf.prefixes;
const unwanted = apiConf.unwanted;

Object.entries(has).forEach(([name, count]) => {
const norm = normalizeString(name, prefixes);
if (!unwanted.has(norm)) {
total += (parseInt(count) || 0);
}
});
return total;
};

const sortResults = () => {
const sortMode = document.getElementById('sortSelect')?.value || 'default';
if (sortMode === 'default') {
allSearchResults.sort((a, b) => (a._p || 0) - (b._p || 0));
} else {
allSearchResults.sort((a, b) => {
const totalA = calculateAccountTotal(a);
const totalB = calculateAccountTotal(b);
if (sortMode === 'count_desc') return totalB - totalA;
if (sortMode === 'count_asc') return totalA - totalB;
return 0;
});
}

// Reset rendering
renderedCount = 0;
const res = document.querySelector("#results");
if (res) res.innerHTML = '';
renderBatch();
};
const renderBatch = () => {
const res = document.querySelector("#results");
if (!res) return;

const nextBatch = allSearchResults.slice(renderedCount, renderedCount + BATCH_SIZE);

nextBatch.forEach(item => {
const card = document.createElement("div");
card.className = "result-card";

const source = item._src || 'Unknown';
const config = API_SOURCES[source];

// 1. Resolve ID (Apply Obfuscation) - Align with v10 fallback chain
const rawId = item.code || item.account_id || item.name || item[config.idKey] || item.id || "N/A";
const displayId = rawId !== "N/A" ? privateToPublicID(rawId, source) : "N/A";

// 2. Resolve Server & Metadata (Align with v10 logic)
let serverName = item.server || "Global";
let info = [];
let emailFound = false;

if (source === 'green') {
const config = API_SOURCES['green'];
{
// Flavor: deck_info or deck_info_kikiyx
let s = '', g = '', l = '';
const di = item.deck_info ? (typeof item.deck_info === 'string' ? JSON.parse(item.deck_info) : item.deck_info) : {};
Object.keys(di || {}).forEach(k => {
const normK = normalizeString(k, config.prefixes);
if (['America', 'Europe', 'Asia', 'SEA', 'HMT'].includes(normK)) {
s = normK;
serverName = normK;
}
if (k.includes('女')) g = 'Female';
if (k.includes('男')) g = 'Male';
});

const srcText = item.source || '';
const lm = srcText.match(/等级[:：]([0-9]+)/);
if (lm) l = lm[1];

if (g) info.push("Gender: " + g);
if (s) info.push("Server: " + s);
if (l) info.push("Level: " + l);

// Email Logic for BSSY/MXWY
if (srcText.includes('企业')) { info.push("Email: Enterprise"); emailFound = true; }
else if (srcText.includes('微软')) { info.push("Email: Microsoft"); emailFound = true; }

}}
if (source === 'mxwy') {
const config = API_SOURCES['mxwy'];
{
// Flavor: deck_info or deck_info_kikiyx
let s = '', g = '', l = '';
const di = item.deck_info ? (typeof item.deck_info === 'string' ? JSON.parse(item.deck_info) : item.deck_info) : {};
Object.keys(di || {}).forEach(k => {
const normK = normalizeString(k, config.prefixes);
if (['America', 'Europe', 'Asia', 'SEA', 'HMT'].includes(normK)) {
s = normK;
serverName = normK;
}
if (k.includes('女')) g = 'Female';
if (k.includes('男')) g = 'Male';
});

const srcText = item.source || '';
const lm = srcText.match(/等级[:：]([0-9]+)/);
if (lm) l = lm[1];

if (g) info.push("Gender: " + g);
if (s) info.push("Server: " + s);
if (l) info.push("Level: " + l);

// Email Logic for BSSY/MXWY
if (srcText.includes('企业')) { info.push("Email: Enterprise"); emailFound = true; }
else if (srcText.includes('微软')) { info.push("Email: Microsoft"); emailFound = true; }

}}
if (source === 'bssy') {
const config = API_SOURCES['bssy'];
{
// Flavor: deck_info or deck_info_kikiyx
let s = '', g = '', l = '';
const di = item.deck_info ? (typeof item.deck_info === 'string' ? JSON.parse(item.deck_info) : item.deck_info) : {};
Object.keys(di || {}).forEach(k => {
const normK = normalizeString(k, config.prefixes);
if (['America', 'Europe', 'Asia', 'SEA', 'HMT'].includes(normK)) {
s = normK;
serverName = normK;
}
if (k.includes('女')) g = 'Female';
if (k.includes('男')) g = 'Male';
});

const srcText = item.source || '';
const lm = srcText.match(/等级[:：]([0-9]+)/);
if (lm) l = lm[1];

if (g) info.push("Gender: " + g);
if (s) info.push("Server: " + s);
if (l) info.push("Level: " + l);

// Email Logic for BSSY/MXWY
if (srcText.includes('企业')) { info.push("Email: Enterprise"); emailFound = true; }
else if (srcText.includes('微软')) { info.push("Email: Microsoft"); emailFound = true; }

}}
if (source === 'chushi') {
const config = API_SOURCES['chushi'];
{
// Chushi uses a description string: "Gender----Server----Level----X" (e.g. "女----America----8----无")
let s = '', g = '', l = '';
const desc = item.description || item.source || '';
const p = desc.split(/[-—–]+/).map(x => x.trim()).filter(Boolean);
if (p.length >= 3) {
g = p[0] === '女' ? 'Female' : (p[0] === '男' ? 'Male' : p[0]);
s = p[1];
l = p[2];
if (s) serverName = s;
}
if (g) info.push("Gender: " + g);
if (s) info.push("Server: " + s);
if (l) info.push("Level: " + l);

// Email Logic for Chushi
if (desc.toLowerCase().includes('email')) { emailFound = true; }

}}
if (source === 'kikiyx') {
const config = API_SOURCES['kikiyx'];
{
// Flavor: deck_info or deck_info_kikiyx
let s = '', g = '', l = '';
const di = item.deck_info ? (typeof item.deck_info === 'string' ? JSON.parse(item.deck_info) : item.deck_info) : {};
Object.keys(di || {}).forEach(k => {
const normK = normalizeString(k, config.prefixes);
if (['America', 'Europe', 'Asia', 'SEA', 'HMT'].includes(normK)) {
s = normK;
serverName = normK;
}
if (k.includes('女')) g = 'Female';
if (k.includes('男')) g = 'Male';
});

const srcText = item.source || '';
const lm = srcText.match(/等级[:：]([0-9]+)/);
if (lm) l = lm[1];

if (g) info.push("Gender: " + g);
if (s) info.push("Server: " + s);
if (l) info.push("Level: " + l);

// Email Logic for BSSY/MXWY
if (srcText.includes('企业')) { info.push("Email: Enterprise"); emailFound = true; }
else if (srcText.includes('微软')) { info.push("Email: Microsoft"); emailFound = true; }

}}

// Default Email (as per v10 "Microsoft" which acts as Outlook)
if (!emailFound) {
info.push("Email: Microsoft");
}

// 3. Resolve Items Data
let has = {};
if (item.deck_info) {
try { has = typeof item.deck_info === 'string' ? JSON.parse(item.deck_info) : item.deck_info; } catch (e) { }
} else if (item.items) {
item.items.forEach(it => { has[it.name] = (has[it.name] || 0) + (it.count || 1); });
}

const charNames = Object.keys(has).filter(name => {
const norm = normalizeString(name, config.prefixes);
// Filter out server/meta cards from items grid
if (['Gender', 'Server', 'Email', 'Level', '性别', '区服'].some(ignore => norm.includes(ignore))) return false;
return !config.unwanted.has(norm);
});

const charHTML = GachaUtils.buildCharGridHTML(charNames.map(name => {
const count = has[name] || 1;
const norm = normalizeString(name, config.prefixes);
const std = translateName(norm);
const customImg = getCustomImage(norm) || getCustomImage(std) || getCustomImage(name);
const imgSrc = customImg || window._characterImageMap?.[std] || '';
return { name: std, img: imgSrc, count: count };
}));

// 4. Extended ID for Copying
const charString = charNames.flatMap(n => Array(has[n] || 1).fill(translateName(normalizeString(n,
config.prefixes)))).join(',');
const extendedId = `${displayId}----${serverName}----[${charString}]`;

const sourceLabel = config.name || source.toUpperCase();
const infoString = info.join(' | ');

card.innerHTML = GachaUtils.buildResultHeaderHTML({ displayId: displayId }) + `
<div class="result-info">${infoString}${appSettings.hide_source ? '' : ` | Source: ${sourceLabel}`}</div>
<div class="chars-row">
    ${charHTML}
</div>
`;

// Event Listeners
GachaUtils.wireResultHeaderButtons(card, {
    onCopy: () => copyToClipboard(extendedId),
    onPriceCheck: () => showPriceCheck(displayId, extendedId)
});

res.appendChild(card);
});

renderedCount += nextBatch.length;
if (renderedCount < allSearchResults.length) GachaUtils.observeLastResultCard(res, resultObserver); };

/* PRICE MODAL — use GachaUtils shared version */
const initPriceModal = () => GachaUtils.initPriceModal({ copyToClipboard });
window.showPriceCheck = GachaUtils.showPriceCheck;


/* INIT HANDLERS */
const sBtn = document.querySelector("#searchBtn");
if (sBtn) sBtn.onclick = performSearch;

const sortSel = document.querySelector("#sortSelect");
if (sortSel) sortSel.onchange = sortResults;

const cBtn = document.querySelector("#clearBtn");
if (cBtn) cBtn.onclick = () => {
selected = {};
document.querySelectorAll('.thumb').forEach(t =>
{t.classList.remove('selected'); t.querySelector('.count-badge')?.remove(); });
const idIn = document.querySelector("#idSearchInput");
if (idIn) idIn.value = '';
updateSelectedUI();
document.querySelector("#results").innerHTML = '';
};
window.copyToClipboard = copyToClipboard;
initPriceModal();
loadResources();

})();